import { css } from "styled-components";

const variables = css`
  :root {
    --background: #0E0D24;
    --gray: #706F71;
    --white: #FFFFFF;
    --purple: #D0A2F7;
    --black: #1A192F;
    --transparent: transparent;

    --font-custom: "Futura";

    --fs-xs: 13px;
    --fs-sm: 16px;
    --fs-md: 21px;
    --fs-lg: 24px;
    --fs-xl: 28px;
    --fs-xxl: 36px;
    --fs-vl: 68px;

    --button-border: 1px solid;
    --button-padding: 18px;

    --padding-subject: 20px;
    --padding-body: 16.67vw;
    --padding-body-lg: 20vw;
    --padding-body-md: 10vw;
    --padding-body-sm: 8.33vw;
    --padding-body-xs: 5vw;

    --border-radius: 8px;
  }
`;

export default variables;
